import React, {useEffect, useState} from "react";
import DonutChart from "../../charts/donut-chart";
import useLocationStore from "../config/use-location-store";
import {instanceMob} from "../../../utils/utils";
import {useNavigate} from "react-router-dom";

const CustomerStatementPanel = () => {
    const { selectedLocation } = useLocationStore();
    const navigate = useNavigate();

    const [debtSummary, setDebtSummary] = useState({
        with_debt_percentage: 0,
        without_debt_percentage: 0,
        total_debt: 0,
        average_debt_days: 0,
    });

    const fetchDebtSummary = () => {
        const locationId = selectedLocation?.id || 73;

        instanceMob
            .get(`admin/accounting/debt-summary?location_id=${locationId}`)
            .then((response) => {
                const data = response.data?.data || response.data || {};
                setDebtSummary({
                    with_debt_percentage: data?.customers_with_debt_pct ?? 0,
                    without_debt_percentage: data?.customers_without_debt_pct ?? 0,
                    total_debt: data?.total_debt_accumulated ?? 0,
                    average_debt_days: data?.average_debt_days ?? 0,
                });
            })
            .catch((error) => {
                console.error("Error fetching debt summary:", error);
                setDebtSummary({
                    with_debt_percentage: 0,
                    without_debt_percentage: 0,
                    total_debt: 0,
                    average_debt_days: 0,
                });
            });
    };

    useEffect(() => {
        fetchDebtSummary();
    }, [selectedLocation]);

    return (
        <div className="accounting-dashboard-customer-statement-panel d-flex flex-column gap-4 p-4">
            <div className="d-flex flex-row justify-content-between align-items-start">
                <div className="d-flex flex-column align-items-start">
                    <div className="accounting-dashboard-customer-statement-panel-title">
                        Estado de Cuenta de Clientes
                    </div>
                    <div className="accounting-dashboard-customer-statement-panel-subtitle">
                        A la fecha
                    </div>
                </div>

                <div className="accounting-dashboard-customer-statement-panel-subtitle d-flex flex-row align-items-center gap-1 cursor-pointer" onClick={() => {navigate("/accounting/client-statement")}}>
                    Ir a Registro de Clientes
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M18 12L18.7071 12.7071L19.4142 12L18.7071 11.2929L18 12ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13L6 12L6 11ZM14 16L14.7071 16.7071L18.7071 12.7071L18 12L17.2929 11.2929L13.2929 15.2929L14 16ZM18 12L18.7071 11.2929L14.7071 7.29289L14 8L13.2929 8.70711L17.2929 12.7071L18 12ZM18 12L18 11L6 11L6 12L6 13L18 13L18 12Z"
                            fill="#9DACBD"
                        />
                    </svg>
                </div>
            </div>

            <div className="d-flex flex-row gap-3">
                <DonutChart
                    colors={["#6FD195", "#000"]}
                    data={[
                        { name: "Sin Deuda", value: debtSummary.without_debt_percentage },
                        { name: "Con Deuda", value: debtSummary.with_debt_percentage },
                    ]}
                />

                <div className="d-flex flex-column gap-4">
                    <div className="d-flex flex-row gap-2 align-items-center justify-content-between">
                        <div className="d-flex flex-row align-items-center gap-2">
                            <div className="accounting-dashboard-customer-statement-panel-dot black" />
                            <div className="accounting-dashboard-customer-statement-panel-label">
                                Con Deuda
                            </div>
                        </div>
                        <div className="accounting-dashboard-customer-statement-panel-label">
                            {debtSummary.with_debt_percentage}%
                        </div>
                    </div>

                    <div className="d-flex flex-row gap-2 align-items-center justify-content-between">
                        <div className="d-flex flex-row align-items-center gap-2">
                            <div className="accounting-dashboard-customer-statement-panel-dot green" />
                            <div className="accounting-dashboard-customer-statement-panel-label">
                                Sin Deuda
                            </div>
                        </div>
                        <div className="accounting-dashboard-customer-statement-panel-label">
                            {debtSummary.without_debt_percentage}%
                        </div>
                    </div>

                    <div className="accounting-dashboard-customer-statement-panel-summary p-3 d-flex flex-column gap-2">
                        <div className="d-flex flex-row justify-content-between align-items-start">
                            <div className="accounting-dashboard-customer-statement-panel-label">
                                Deuda Total Acumulada
                            </div>
                            <div className="accounting-dashboard-customer-statement-panel-label text-end w-50">
                                ${debtSummary.total_debt.toLocaleString()}
                            </div>
                        </div>
                        <div className="d-flex flex-row justify-content-between align-items-start">
                            <div className="accounting-dashboard-customer-statement-panel-label">
                                Tiempo Promedio de Deudas
                            </div>
                            <div className="accounting-dashboard-customer-statement-panel-label text-end w-50">
                                {debtSummary.average_debt_days} días
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerStatementPanel;
